import React from 'react';
import { AppBar, Toolbar, Box, useTheme, useMediaQuery, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ isAuthenticated, setIsAuthenticated }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    navigate('/signin');
  };

  return (
    <AppBar 
      position="static" 
      sx={{ 
        backgroundColor: '#FFFFFF', 
        boxShadow: 'none', 
        borderBottom: '1px solid #E2E2E3'
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', height: '56px', padding: '16px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="/logo.png" 
            alt="Logo" 
            style={{ 
              height: isMobile ? '24px' : '32px', 
              marginRight: '16px' 
            }} 
          />
        </Box>
        {isAuthenticated && (
          <Button 
            onClick={handleSignOut}
            sx={{ 
              color: 'black',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            Sign Out
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;